/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon24Solid = forwardRef('MailIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6Zm.64 3.732a1 1 0 1 0-1.28 1.536l4.08 3.4a4 4 0 0 0 5.12 0l4.08-3.4a1 1 0 1 0-1.28-1.536l-4.08 3.4a2 2 0 0 1-2.56 0l-4.08-3.4Z" })));
});
